import "@/App.css";
import { useLenisScroll } from "./hooks/useLenisScroll";
import { useButtonFx } from "./hooks/useButtonFx";
import { CosmicBackground } from "./components/CosmicBackground";
import { PageLoader } from "./components/PageLoader";
import { CustomCursor } from "./components/CustomCursor";
import { FxLayer } from "./components/FxLayer";
import { Navbar } from "./components/sections/Navbar";
import { Hero } from "./components/sections/Hero";
import { Intro } from "./components/sections/Intro";
import { Zodiac } from "./components/sections/Zodiac";
import { Benefits } from "./components/sections/Benefits";
import { Tarot } from "./components/sections/Tarot";
import { Services } from "./components/sections/Services";
import { Stats } from "./components/sections/Stats";
import { Testimonials } from "./components/sections/Testimonials";
import { Pricing } from "./components/sections/Pricing";
import { CTA } from "./components/sections/CTA";
import { Footer } from "./components/sections/Footer";

function App() {
  useLenisScroll();
  useButtonFx();

  return (
    <div className="App">
      <PageLoader />
      <CustomCursor />
      <FxLayer />
      <div className="film-grain" data-testid="film-grain-overlay" />
      <CosmicBackground />
      <div className="relative z-10">
        <Navbar />
        <main>
          <Hero />
          <Intro />
          <Zodiac />
          <Benefits />
          <Tarot />
          <Services />
          <Stats />
          <Testimonials />
          <Pricing />
          <CTA />
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default App;
